export enum ProductState {
	DEVELOPMENT = 'development',
	OUTDATED = 'outdated',
	RELEASED = 'released'
}
